var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-content",
        [
          _c(
            "v-img",
            {
              attrs: {
                src: _vm.headerImage,
                gradient:
                  "to top right, rgba(63,81,181, .3), rgba(25,32,72, .2)",
                position: "center center",
                height: "400"
              }
            },
            [
              _c(
                "v-container",
                { attrs: { "fill-height": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("h1", { staticClass: "display-3 white--text" }, [
                            _vm._v("KNOWMAK"),
                            _c("br"),
                            _vm._v("Explore Knowledge Production in Europe")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0 space-button",
                              attrs: {
                                slot: "activator",
                                large: "",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$vuetify.goTo("#datastories", {
                                    offset: 0,
                                    duration: 600,
                                    easing: "easeInOutCubic"
                                  })
                                }
                              },
                              slot: "activator"
                            },
                            [_vm._v("Study data stories")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0 hidden-sm-and-down",
                              attrs: {
                                slot: "activator",
                                large: "",
                                to: "/dashboard",
                                color: "primary"
                              },
                              slot: "activator"
                            },
                            [_vm._v("\n            Dive right in!")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              staticClass: "hidden-md-and-up",
                              attrs: {
                                sm: "",
                                bottom: "",
                                "max-width": "200",
                                color: "warning",
                                "content-class": "mobile_warning"
                              },
                              model: {
                                value: _vm.showWarning.btn1,
                                callback: function($$v) {
                                  _vm.$set(_vm.showWarning, "btn1", $$v)
                                },
                                expression: "showWarning.btn1"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    slot: "activator",
                                    large: "",
                                    color: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleWarning("btn1")
                                    }
                                  },
                                  slot: "activator"
                                },
                                [_vm._v("\n              Dive right in!")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.mobileWarning))])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-content",
            [
              _c(
                "v-container",
                {
                  attrs: {
                    fluid: "",
                    "fill-height": "",
                    "pt-5": "",
                    "pb-4": ""
                  }
                },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        row: "",
                        wrap: "",
                        "align-start": "",
                        "justify-space-around": "",
                        "px-5": "",
                        "pt-4": ""
                      }
                    },
                    _vm._l(_vm.taglines, function(t) {
                      return _c(
                        "v-flex",
                        {
                          key: t.icon,
                          attrs: { xs12: "", sm4: "", "pb-3": "", "mb-4": "" }
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "text-xs-center",
                              attrs: { color: "transparent", flat: "" }
                            },
                            [
                              _c(
                                "v-img",
                                { attrs: { height: "5rem", contain: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "icon",
                                        attrs: { icon: t.icon }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-title",
                                { staticClass: "headline justify-center" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(t.headline) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-card-text", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(t.content) +
                                    "\n            "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-content",
            { attrs: { id: "datastories" } },
            [
              _c(
                "v-container",
                {
                  class: { "px-0": _vm.$vuetify.breakpoint.smAndUp },
                  attrs: { white: "", "fill-height": "", fluid: "", "py-0": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "align-center": "" } },
                    _vm._l(_vm.newestDataStories, function(story, index) {
                      return _c(
                        "v-content",
                        { key: index },
                        [
                          _c("data-story", {
                            attrs: {
                              datastory: story,
                              reversing: index % 2 == 0 ? true : false
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("story-archive", {
            attrs: {
              id: "datastories-archive",
              "archived-stories": _vm.dataStoriesArchive
            }
          }),
          _vm._v(" "),
          _c(
            "v-img",
            {
              attrs: {
                src: _vm.footerImage,
                gradient:
                  "to top right, rgba(63,81,181, .3), rgba(25,32,72, .2)",
                height: "400"
              }
            },
            [
              _c(
                "v-container",
                { attrs: { "fill-height": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("h3", { staticClass: "display-1 white--text" }, [
                            _vm._v("Interested?")
                          ]),
                          _vm._v(" "),
                          _c("h3", { staticClass: "display-1 white--text" }, [
                            _vm._v("Start your own exploration now!")
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-0 hidden-sm-and-down",
                              attrs: {
                                slot: "activator",
                                large: "",
                                to: "/dashboard",
                                color: "primary"
                              },
                              slot: "activator"
                            },
                            [_vm._v("\n            Try it out")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              staticClass: "hidden-md-and-up",
                              attrs: {
                                bottom: "",
                                "max-width": "200",
                                color: "warning",
                                "content-class": "mobile_warning"
                              },
                              model: {
                                value: _vm.showWarning.btn2,
                                callback: function($$v) {
                                  _vm.$set(_vm.showWarning, "btn2", $$v)
                                },
                                expression: "showWarning.btn2"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    slot: "activator",
                                    large: "",
                                    color: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleWarning("btn2")
                                    }
                                  },
                                  slot: "activator"
                                },
                                [_vm._v("Try it out")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.mobileWarning))])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-footer",
            { staticClass: "grey lighten-2", attrs: { height: "auto" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "justify-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "text-xs-center",
                          attrs: { flat: "", tile: "" }
                        },
                        [
                          _c(
                            "v-card-text",
                            _vm._l(_vm.weblinks, function(w, i) {
                              return _c(
                                "v-btn",
                                {
                                  key: i,
                                  attrs: {
                                    color: "euflag",
                                    flat: "",
                                    href: w.url,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(w.label) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        "justify-center": "",
                        color: "grey lighten-2"
                      }
                    },
                    [
                      _c(
                        "v-content",
                        { attrs: { color: "grey lighten-2" } },
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "text-xs-center": "" } },
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "align-center": "",
                                    "justify-center": "",
                                    "pt-2": "",
                                    "text-xs-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        "pa-1": "",
                                        xs12: "",
                                        sm3: "",
                                        md3: "",
                                        lg2: "",
                                        xl1: ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          attrs: {
                                            flat: "",
                                            tile: "",
                                            color: "transparent",
                                            height: "60px"
                                          }
                                        },
                                        [
                                          _c("v-img", {
                                            attrs: {
                                              contain: "",
                                              height: "60px",
                                              href: "#",
                                              src: require("@/assets/img/logos/eu_flag.svg")
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-container",
                            {
                              staticClass: "euflag--text",
                              attrs: {
                                "pt-0": "",
                                "text-xs-center": "",
                                caption: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n            This project has received funding from the European Union's Horizon 2020 research and innovation programme under grant agreement No. 726992\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f74f74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f74f74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = null
// module chunks = 